export default __webpack_public_path__ + "static/char-33-6faf9fba87337f333c3ad12cc1a345fe.webp";